<template>
  <div id="app">
    <commonhead :active_menu="-1" />
    <div class="user_center_rights">
      <div class="content_wrap">
        <!--个人中心公用侧边栏-->
        <UserLeftMenu :active_menu_index="3" />
        <div class="right_content">
          <!--学币余额-->
          <div class="balance">
            <p class="head_title">学币余额</p>
            <p class="total_info">
              您是
              <span class="red">普通会员</span>学币余额
              <span class="red">{{user_info.coins}}学币</span>
              <!-- 有效期至<span class="red">2020-10-08 15:56</span> -->
            </p>
            <p class="notice_text">学币是鲸贝英语平台的价值流通单元，可代替人民币进行支付。</p>
            <button class="check_vip hand_point">查看会员权限</button>
          </div>
          <div class="rights_area" id="right">
            <p class="head_title">会员权利</p>
            <div class="right_wrap">
              <div
                :class="active_menu == 0 ? 'rights_item active':'rights_item'"
                @mouseover="active_this(0)"
                @mouseout="active_this(-1)"
              >
                <div class="rights_detail">
                  <p class="item_1"></p>
                  <p class="item_2">加入条件</p>
                  <p class="item_3">学币</p>
                  <p class="item_4">有效期</p>
                  <p class="item_5">可预约时间</p>
                  <p class="item_6">上课短信提醒</p>
                  <p class="item_7">单节现金支付</p>
                  <p class="item_8"></p>
                </div>
              </div>
              <div
                :class="active_menu == index+1 ? 'rights_item active':'rights_item'"
                @mouseover="active_this(index+1)"
                @mouseout="active_this(-1)"
                v-for="(item,index) in tableData"
                :key="index"
              >
                <div class="rights_detail">
                  <p class="item_1">{{item.name}}</p>
                  <p class="item_2">
                    购买学币
                    <span class="red">￥</span>
                    <span class="num">{{item.price}}</span>
                  </p>
                  <p class="item_3">{{item.coins}}学币</p>
                  <p class="item_4">{{item.privilege_month}}个月</p>
                  <p class="item_5">{{item.type == 0 ? '三天':item.type == 1 ? '一周':'二周'}}</p>
                  <p class="item_6">
                    <span class="icon" v-if="index == 0">
                      <img src="../../assets/image/user_center/wrong.png" alt class="pic_full" />
                    </span>
                    <span class="icon" v-else>
                      <img src="../../assets/image/user_center/right.png" alt class="pic_full" />
                    </span>
                  </p>
                  <p class="item_7">
                    <span class="icon">
                      <img src="../../assets/image/user_center/right.png" alt class="pic_full" />
                    </span>
                  </p>
                  <p class="item_8">
                    <button class="buy_btn hand_point" @click="$router.push('./user-center-buy?id='+item.id)">立即购买</button>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="rights_area">
            <p class="head_title">常见问题</p>
            <div class="q_a">
              <p class="item_q">
                <span class="red">Q:</span> 会员到有效期后，学币会清零吗？
              </p>
              <p class="item_q dif">
                <span class="green">A:</span> 会清零，相应的权限将会收回。可通过购买会员延长有效期。
              </p>
              <p class="item_q">
                <span class="red">Q:</span> 购买了两次学币，有效期怎么算？
              </p>
              <p class="item_q dif">
                <span class="green">A:</span> 有效期采用累加的计算方法。
              </p>
              <p class="item_q">
                <span class="red">Q:</span> 学币能提现吗？
              </p>
              <p class="item_q">
                <span class="green">A:</span> 暂不提供提现功能。
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--底部信息-->
    <div class="bottom">
      <div class="content pr">
        <span class="gift">
          <img src="../../assets/image/user_center/icon (1).png" alt class="pic_full" />
        </span>
        <span class="free_info">
          每成功推荐一个朋友学习，满足奖励条件后即可获得
          <span class="red">200元充值</span>，奖励可累积哦！
        </span>
        <div class="qr_code">
          <div class="qrcode_img">
            <canvas id="QRCode"></canvas>
          </div>
          <p class="notice_info">
            <span class="wechat_icon">
              <img src="../../assets/image/user_center/icon (2).png" alt class="pic_full" />
            </span>
            <span>扫码分享到微信</span>
          </p>
        </div>
        <button class="call_btn hand_point">查看奖励</button>
      </div>
    </div>
    <!--公共底部-->
    <commonfoot />
    <!--公共底部-->
  </div>
</template>

<script>
import { common } from "../../../common.js";
import commonhead from "../common/common_head.vue";
import commonfoot from "../common/common_foot.vue";
import UserLeftMenu from "../common/user_left_menu.vue";
import QRCode from "qrcode"; //引入生成二维码插件
export default {
  name: "app",
  components: {
    commonhead,
    commonfoot,
    UserLeftMenu
  },
  data: function() {
    return {
      active_menu: -1,
      tableData: "",
      user_info: ""
    };
  },
  mounted: function() {
    this.getList();
    this.get_info();
    this.get_share_code();
  },
  methods: {
    active_this(num) {
      this.active_menu = num;
    },
    getList() {
      //获取列表
      let self = this;
      common.requestFun(self, "get", "/vip/price", {}, res => {
        if (res.data.code == 200) {
          self.tableData = res.data.data;
        }
      });
    },
    get_info() {
      let self = this;
      common.requestFun(self, "get", "/student/profile", {}, res => {
        if (res.data.code == 200) {
          self.user_info = res.data.data;
        }
      });
    },
    get_share_code() {
      //生成分享二维码
      let self = this;
      common.requestFun(self, "get", "/student/recommend_code", {}, res => {
        if (res.data.code == 200) {
          var msg = document.getElementById("QRCode");
          QRCode.toCanvas(
            msg,
            `http://gemsbaby.com/share/index.html?origin_code=${res.data.data}`,
            function(error) {
              console.log(error);
            }
          );
        }
      });
    }
  }
};
</script>
<style scoped src="./user_center_rights.css"></style>
